import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Typography,
  Button,
  InputAdornment,
  styled,
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  FormControl,
  OutlinedInput,
  Select,
  MenuItem,
  FormHelperText,
  Checkbox,
  ListItemText,
  Chip,
} from "@mui/material";
import axios from "axios";
import { otherBaseURL } from "../config";
import "./Teammates.scss";
import SearchIcon from "@mui/icons-material/Search";
import LocalPostOfficeIcon from "@mui/icons-material/LocalPostOffice";
import { DialogTitleProps } from "../SideMenu/SideMenu";
import CloseIcon from "@mui/icons-material/Close";
import Logo from "../assets/slate-logo.svg";
import { Bars } from "react-loader-spinner";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { width } from "@amcharts/amcharts4/.internal/core/utils/Utils";
export const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
    borderBottom: "1px solid #f7b047",
    borderTop: "1px solid #f7b047",
  },

  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },

  "& .MuiDialogTitle-root": {
    color: "#f7b047",
    padding: "10px",
  },
  "& .MuiSvgIcon-root": {
    color: "#f7b047",
  },
  "& .MuiButton-root": {
    color: "#f7b047",
  },
  "& .MuiDialog-paper": {
    maxWidth: "44%",
    background:
      "linear-gradient(0deg, #13223D, #234f70 100%) no-repeat !important",
  },
}));

export const BootstrapDialogTitle = (props: DialogTitleProps) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};
const US_STATES: any = [
  "California",
  "Florida",
  "Texas",
  "Tennessee",
  "Arizona",
  "North Carolina",
  "Indiana",
  "South Carolina",
  "Colorado",
  "Georgia",
  "Utah",
  "Illinois",
  "Idaho",
  "Minnesota",
  "Oregon",
  "Washington",
  "Virginia",
  "Wisconsin",
  "Alabama",
  "Arkansas",
  "Connecticut",
  "Delaware",
  "Iowa",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Maryland",
  "Michigan",
  "Missouri",
  "Ohio",
  "Pennsylvania",
  "West Virginia",
  "Mississippi",
  "Nebraska",
  "Vermont",
  "Massachusetts",
  "New Mexico",
  "Hawaii",
  "South Dakota",
  "Alaska",
  "Rhode Island",
  "New Hampshire",
  "Nevada",
  "New Jersey",
  "New York",
  "Oklahoma",
];
const stateAbbreviations: Record<string, string> = {
  California: "CA",
  Florida: "FL",
  Texas: "TX",
  Tennessee: "TN",
  Arizona: "AZ",
  "North Carolina": "NC",
  Indiana: "IN",
  "South Carolina": "SC",
  Colorado: "CO",
  Georgia: "GA",
  Utah: "UT",
  Illinois: "IL",
  Idaho: "ID",
  Minnesota: "MN",
  Oregon: "OR",
  Washington: "WA",
  Virginia: "VA",
  Wisconsin: "WI",
  Alabama: "AL",
  Arkansas: "AR",
  Connecticut: "CT",
  Delaware: "DE",
  Iowa: "IA",
  Kansas: "KS",
  Kentucky: "KY",
  Louisiana: "LA",
  Maryland: "MD",
  Michigan: "MI",
  Missouri: "MO",
  Ohio: "OH",
  Pennsylvania: "PA",
  "West Virginia": "WV",
  Mississippi: "MS",
  Nebraska: "NE",
  Vermont: "VT",
  Massachusetts: "MA",
  "New Mexico": "NM",
  Hawaii: "HI",
  "South Dakota": "SD",
  Alaska: "AK",
  "Rhode Island": "RI",
  "New Hampshire": "NH",
  Nevada: "NV",
  "New Jersey": "NJ",
  "New York": "NY",
  Oklahoma: "OK",
};

const Teammates = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [teamData, setTeamData] = useState<any>([]);
  const [isOpen, setOpen] = React.useState(false);
  const [isStateOpen, setIsStateOpen] = React.useState(false);
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [phone, setPhone] = useState("");
  const [showError, setShowError] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [errorMsg, setErrorMessage] = useState("");
  const [isLoading, setLoading] = useState(true);
  const [userloading, setUserLoading] = React.useState(false);
  const [selectedStates, setSelectedStates] = useState<any>([]);
  const [changedStates, setChangedStates] = useState<any>([]);
  const [updateEmail, setUpdateEmail] = useState("");


  useEffect(() => {
    loadUsers();
  }, []);

  const loadUsers = async () => {
    const response1 = await axios
      .get(`${otherBaseURL}getAllUsers`)
      .then(async (response: any) => {
        setTeamData(response.data);
      })
      .catch((error) => {
        // console.log(error)
        // setShowError(true);
        // setErrorMessage('😕 Username/password is incorrect')
      });
  };

  const filteredTeamData = teamData.filter((member: any) =>
    `${member.firstname} ${member.lastname}`
      .toLowerCase()
      .includes(searchQuery.toLowerCase())
  );
  const handleCloseDialog = () => {
    setOpen(false);
    setEmail("");
    setRole("");
    setFirstName("");
    setLastName("");
    setShowConfirmation(false);
    setShowError(false);
    setSelectedStates([]);
  };
  const handleCloseStateDialog = () => {
    setIsStateOpen(false);
    setChangedStates([]);
  };
  const handleStateChange = (event: any) => {
    const { value } = event.target;
    if (value.includes("all")) {
      if (selectedStates.length === US_STATES.length) {
        setSelectedStates([]);
      } else {
        setSelectedStates(US_STATES);
      }
    } else {
      setSelectedStates(typeof value === "string" ? value.split(",") : value);
    }
  };

  const handleRemoveState = (stateToRemove: any) => {
    setSelectedStates((prevStates: any) =>
      prevStates.filter((state: any) => state !== stateToRemove)
    );
  };
  const handleRemoveChangedState = (stateToRemove: any) => {
    setChangedStates((prevStates: any) =>
      prevStates.filter((state: any) => state !== stateToRemove)
    );
  };

  const getForms = () => {
    return (
      <form
        className="ftLogin_container_form"
        onSubmit={(ev) => {
          ev.preventDefault();
          addUser();
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <FormControl sx={{ m: 2, width: "95%" }}>
            <Typography className="form_label" gutterBottom>
              Email*
            </Typography>
            <OutlinedInput
              className="form_input_name"
              name="email"
              value={email}
              onChange={handleInputChange}
              autoComplete="off"
            />
          </FormControl>
          <div style={{ position: "relative", left: "-20px" }}>
            <Typography
              className="form_label"
              gutterBottom
              style={{ marginLeft: "14px" }}
            >
              Role*
            </Typography>
            <Select
              value={role}
              label="Select value as"
              onChange={handleInputChange}
              name="role"
              className="role_dropdown"
              autoComplete="off"
            >
              <MenuItem value={"user"}>User</MenuItem>
              <MenuItem value={"admin"}>Admin</MenuItem>
              <MenuItem value={"trial"}>Trial</MenuItem>
            </Select>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "transparent",
          }}
        >
          <FormControl sx={{ m: 2, width: "95%" }}>
            <Typography className="form_label" gutterBottom>
              First Name*
            </Typography>
            <OutlinedInput
              className="form_input_name"
              name="firstName"
              value={firstName}
              onChange={handleInputChange}
              autoComplete="off"
            />
          </FormControl>
          <FormControl sx={{ m: 2, width: "95%" }}>
            <Typography className="form_label" gutterBottom>
              Last Name*
            </Typography>
            <OutlinedInput
              className="form_input_name"
              name="lastName"
              value={lastName}
              onChange={handleInputChange}
              autoComplete="off"
            />
          </FormControl>
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <FormControl sx={{ m: 2, width: "95%" }}>
            <Typography className="form_label" gutterBottom>
              Company Name(optional)
            </Typography>
            <OutlinedInput
              className="form_input_name"
              name="companyName"
              value={companyName}
              onChange={handleInputChange}
              autoComplete="off"
            />
          </FormControl>
          <FormControl sx={{ m: 2, width: "95%" }}>
            <Typography className="form_label" gutterBottom>
              Phone(optional)
            </Typography>
            <OutlinedInput
              type="number"
              className="form_input_name"
              name="phone"
              value={phone}
              onChange={handleInputChange}
              autoComplete="off"
            />
          </FormControl>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <FormControl sx={{ m: 2, width: "95%" }}>
            <Typography className="form_label" gutterBottom>
              Select States*
            </Typography>
            <Select
              multiple
              value={selectedStates}
              onChange={handleStateChange}
              displayEmpty
              renderValue={(selected) => (
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "8px",
                    alignItems: "center",
                    zIndex: 2000,
                  }}
                >
                  {selected.map((state: any) => (
                    <div
                      key={state}
                      onMouseDown={(event) => {
                        event.stopPropagation(); // Prevent dropdown from opening
                      }}
                    >
                      <Chip
                        label={state}
                        onDelete={() => handleRemoveState(state)}
                        sx={{
                          backgroundColor: "transparent",
                          color: "#fff",
                          border: "1px solid #F7B047",
                          "& .MuiChip-deleteIcon": {
                            color: "#F7B047",
                          },
                        }}
                      />
                    </div>
                  ))}
                </div>
              )}
              MenuProps={{
                PaperProps: {
                  sx: {
                    "& .MuiList-root .Mui-selected": {
                      backgroundColor: "transparent !important",
                    },
                    "& .MuiList-root .Mui-selected:hover": {
                      backgroundColor: "transparent !important",
                    },
                    "& .MuiList-root .MuiMenuItem-root:hover": {
                      backgroundColor: "transparent !important",
                    },
                  },
                },
              }}
              input={
                <OutlinedInput
                  style={{
                    backgroundColor: "transparent !important", // Input field background transparent with !important
                    color: "white !important",
                    border: "none", // Input text color as white with !important
                    borderBottom: "1px solid #F7B047 !important;",
                  }}
                />
              }
              sx={{
                "& .MuiSelect-select": {
                  backgroundColor: "transparent !important", // Dropdown selection background transparent with !important
                  color: "white !important", // Dropdown text color as white with !important
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "white !important",
                  border: "1px solid black !important;", // Input text color as white with !important
                  borderBottom: "1px solid #F7B047 !important;", // Border color as white with !important
                },
              }}
            >
              {/* Add the "Select All" option */}
              <MenuItem
                value="all"
              >
                <Checkbox
                  sx={{
                    color: "#F7B047",
                    "&.Mui-checked": {
                      color: "#F7B047",
                    },
                    "&.MuiCheckbox-indeterminate": {
                      color: "#F7B047",
                    },
                  }}
                  indeterminate={
                    selectedStates.length > 0 &&
                    selectedStates.length < US_STATES.length
                  }
                  checked={selectedStates.length === US_STATES.length}
                />
                <ListItemText primary="Select All" />
              </MenuItem>

              {US_STATES.map((state: any) => (
                <MenuItem
                  key={state}
                  value={state}
                  sx={{
                    backgroundColor: "transparent !important",
                    "&.Mui-selected": {
                      backgroundColor: "transparent !important",
                    },
                    "&.Mui-selected:hover": {
                      backgroundColor: "transparent !important",
                    },
                    "&:hover": {
                      backgroundColor: "transparent !important",
                    },
                  }}
                >
                  <Checkbox
                    sx={{
                      color: "#F7B047",
                      "&.Mui-checked": {
                        color: "#F7B047",
                      },
                      "&.MuiCheckbox-indeterminate": {
                        color: "#F7B047",
                      },
                    }}
                    checked={selectedStates.indexOf(state) > -1}
                  />
                  <ListItemText primary={state} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>

        <FormControl
          sx={{ m: 2 }}
          style={{ margin: "12px", display: "flex", alignItems: "center" }}
        >
          <Button
            variant="outlined"
            // onClick={() => login()}
            disabled={
              !email ||
              !role ||
              !firstName ||
              !lastName ||
              selectedStates.length === 0 // Disable if conditions not met
            }
            type="submit"
            className="loginButton"
            sx={{
              backgroundColor:
                !email ||
                !role ||
                !firstName ||
                !lastName ||
                (role === "trial" && selectedStates.length === 0)
                  ? "rgba(255, 255, 255, 0.3) !important" // Disabled background
                  : "rgba(220, 131, 38, 0.9215686274509803) !important", // Enabled background
              color:
                !email ||
                !role ||
                !firstName ||
                !lastName ||
                (role === "trial" && selectedStates.length === 0)
                  ? "rgba(255, 255, 255, 0.5) !important" // Disabled text color
                  : "#fff !important", // Enabled text color
              border: "1px solid #035F77 !important", // Border color remains consistent
              "&:hover": {
                backgroundColor: "#004d60 !important", // Hover color for enabled state
              },
            }}
          >
            Add Account
            <Bars
              height="30"
              color="#035F77"
              ariaLabel="bars-loading"
              wrapperStyle={{ float: "left" }}
              wrapperClass=""
              visible={userloading}
            />
          </Button>
        </FormControl>

        {showConfirmation && (
          <div className="errorContainer">
            <FormControl sx={{ m: 1 }}>
              <FormHelperText id="accountId-error">
                Invitation sent Successfully
              </FormHelperText>
            </FormControl>
          </div>
        )}

        {showError && (
          <div className="errorContainer">
            <FormControl sx={{ m: 1 }}>
              <FormHelperText error id="accountId-error">
                {errorMsg}
              </FormHelperText>
            </FormControl>
          </div>
        )}
      </form>
    );
  };
  const getStatesDropDown = () => {
    return (
      <form
        className="ftLogin_container_form"
        onSubmit={(ev) => {
          ev.preventDefault();
          UpdateState();
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <FormControl sx={{ m: 2, width: "95%" }}>
            <Typography className="form_label" gutterBottom>
              Select States*
            </Typography>
            <Select
              multiple
              value={changedStates}
              onChange={handleStatePopoverChange}
              displayEmpty
              renderValue={(selected) => (
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "8px",
                    alignItems: "center",
                    zIndex: 2000,
                  }}
                >
                  {selected.map((state: any) => (
                    <div
                      key={state}
                      onMouseDown={(event) => {
                        event.stopPropagation(); // Prevent dropdown from opening
                      }}
                    >
                      <Chip
                        label={state}
                        onDelete={() => handleRemoveChangedState(state)}
                        sx={{
                          backgroundColor: "transparent",
                          color: "#fff",
                          border: "1px solid #F7B047",
                          "& .MuiChip-deleteIcon": {
                            color: "#F7B047",
                          },
                        }}
                      />
                    </div>
                  ))}
                </div>
              )}
              MenuProps={{
                PaperProps: {
                  sx: {
                    "& .MuiList-root .Mui-selected": {
                      backgroundColor: "transparent !important",
                    },
                    "& .MuiList-root .Mui-selected:hover": {
                      backgroundColor: "transparent !important",
                    },
                    "& .MuiList-root .MuiMenuItem-root:hover": {
                      backgroundColor: "transparent !important",
                    },
                  },
                },
              }}
              input={
                <OutlinedInput
                  style={{
                    backgroundColor: "transparent !important", // Input field background transparent with !important
                    color: "white !important",
                    border: "none", // Input text color as white with !important
                    borderBottom: "1px solid #F7B047 !important;",
                  }}
                />
              }
             
            >
              {/* Add the "Select All" option */}
              <MenuItem
                value="all"
                sx={{
                  backgroundColor: "transparent !important",
                  "&.Mui-selected": {
                    backgroundColor: "transparent !important",
                  },
                  "&.Mui-selected:hover": {
                    backgroundColor: "transparent !important",
                  },
                  "&:hover": {
                    backgroundColor: "transparent !important",
                  },
                }}
              >
                <Checkbox
                  sx={{
                    color: "#F7B047",
                    "&.Mui-checked": {
                      color: "#F7B047",
                    },
                    "&.MuiCheckbox-indeterminate": {
                      color: "#F7B047",
                    },
                  }}
                  indeterminate={
                    changedStates.length > 0 &&
                    changedStates.length < US_STATES.length
                  }
                  checked={changedStates.length === US_STATES.length}
                />
                <ListItemText primary="Select All" />
              </MenuItem>

              {US_STATES.map((state: any) => (
                <MenuItem
                  key={state}
                  value={state}
                  sx={{
                    backgroundColor: "transparent !important",
                    "&.Mui-selected": {
                      backgroundColor: "transparent !important",
                    },
                    "&.Mui-selected:hover": {
                      backgroundColor: "transparent !important",
                    },
                    "&:hover": {
                      backgroundColor: "transparent !important",
                    },
                  }}
                >
                  <Checkbox
                    sx={{
                      color: "#F7B047",
                      "&.Mui-checked": {
                        color: "#F7B047",
                      },
                      "&.MuiCheckbox-indeterminate": {
                        color: "#F7B047",
                      },
                    }}
                    checked={changedStates.indexOf(state) > -1}
                  />
                  <ListItemText primary={state} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>

        <FormControl
          sx={{ m: 2 }}
          style={{ margin: "12px", display: "flex", alignItems: "center" }}
        >
          <Button
            variant="outlined"
            // onClick={() => login()}
            disabled={
              changedStates.length === 0 // Disable if conditions not met
            }
            type="submit"
            className="loginButton"
            sx={{
              backgroundColor:
                (changedStates.length === 0)
                  ? "rgba(255, 255, 255, 0.3) !important" // Disabled background
                  : "rgba(220, 131, 38, 0.9215686274509803) !important", // Enabled background
              color:
                ( changedStates.length === 0)
                  ? "rgba(255, 255, 255, 0.5) !important" // Disabled text color
                  : "#fff !important", // Enabled text color
              border: "1px solid #035F77 !important", // Border color remains consistent
              "&:hover": {
                backgroundColor: "#004d60 !important", // Hover color for enabled state
              },
            }}
          >
            Update
            <Bars
              height="30"
              color="#035F77"
              ariaLabel="bars-loading"
              wrapperStyle={{ float: "left" }}
              wrapperClass=""
              visible={userloading}
            />
          </Button>
        </FormControl>

        {showConfirmation && (
          <div className="errorContainer">
            <FormControl sx={{ m: 1 }}>
              <FormHelperText id="accountId-error">
                States Updated Successfully
              </FormHelperText>
            </FormControl>
          </div>
        )}

        {showError && (
          <div className="errorContainer">
            <FormControl sx={{ m: 1 }}>
              <FormHelperText error id="accountId-error">
                {errorMsg}
              </FormHelperText>
            </FormControl>
          </div>
        )}
      </form>
    );
  };
  const handleInputChange = (ev: any) => {
    if (ev.target.name === "email") {
      setShowError(false);
      setEmail(ev.target.value);
    } else if (ev.target.name === "firstName") {
      setShowError(false);
      setFirstName(ev.target.value);
    } else if (ev.target.name === "companyName") {
      setShowError(false);
      setCompanyName(ev.target.value);
    } else if (ev.target.name === "phone") {
      setShowError(false);
      setPhone(ev.target.value);
    } else if (ev.target.name === "lastName") {
      setShowError(false);
      setLastName(ev.target.value);
    } else if (ev.target.name === "role") {
      setShowError(false);
      setRole(ev.target.value);
    }
  };
  const addUser = async () => {
    setShowError(false);
    setShowConfirmation(false);
    if (email === "" || firstName === "" || lastName === "") {
      setShowError(true);
      setErrorMessage("😕 Please fill out the empty fields");
      return;
    }
    const payload: any = {
      email: email.toLowerCase(),
      firstname: firstName,
      lastname: lastName,
      role: role,
      contact: phone,
      company: companyName,
      is_trial: role === "trial" ? true : false,
      allowed_states:
        selectedStates.length === US_STATES.length ? [] : selectedStates,
    };
    const response = await axios
      .post(`${otherBaseURL}register`, payload)
      .then((responce) => {
        console.log(responce);
        setShowConfirmation(true);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setShowError(true);
        setErrorMessage("😕 Username/Email already exists");
        setLoading(false);
      });
  };
  const UpdateState = async () => {
    setShowError(false);
    setShowConfirmation(false);
  
    const payload: any = {
      "email": updateEmail,
      "allowed_states":changedStates  }
    const response = await axios
      .post(`${otherBaseURL}updateStates`, payload)
      .then((responce) => {
        console.log(responce);
        setShowConfirmation(true);
        setLoading(false);
        loadUsers()
        setTimeout(()=>{
          setIsStateOpen(false)
        },1000)
      })
      .catch((error) => {
        console.log(error);
        setShowError(true);
        setErrorMessage("Error while updating the states");
        setLoading(false);
      });
  };

  const handleReInvite = async (user: any) => {
    const payload: any = {
      email: user.email.toLowerCase(),
      firstname: user.firstname,
      lastname: user.lastname,
      role: user.role,
      contact: user.contact,
      company: user.company,
    };
    const response = await axios
      .post(`${otherBaseURL}register`, payload)
      .then((responce) => {
        toast.success("Email Sent Successfully!", {
          position: "top-right",
        });
      })
      .catch((error) => {
        console.log(error);
        setShowError(true);
        setErrorMessage(error.message);
        setLoading(false);
        toast.error(error, {
          position: "top-right",
        });
      });
  };

  const handleStatePopover=(states:any,email:string)=>{
    setIsStateOpen(true)
    setUpdateEmail(email)
    if(states.length===0){
      setChangedStates(US_STATES)
    }
    else{
      setChangedStates(states)
    }
  }

  const handleStatePopoverChange = (event: any) => {
    const { value } = event.target;
    if (value.includes("all")) {
      if (changedStates.length === US_STATES.length) {
        setChangedStates([]);
      } else {
        setChangedStates(US_STATES);
      }
    } else {
      setChangedStates(typeof value === "string" ? value.split(",") : value);
    }
  };
  return (
    <div className="teammates-main">
      <div className="teammates-main__header">
        <span>Teammates</span>
        <p>Add & Invite new teammates</p>
      </div>
      <div className="teammates-main__search">
        <TextField
          label="Search by username"
          variant="outlined"
          margin="normal"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon style={{ color: "#aaa" }} />
              </InputAdornment>
            ),
          }}
          sx={{
            "& .MuiOutlinedInput-root": {
              marginRight: "20px",
              color: "white",
              height: "40px",
              "& fieldset": {
                borderColor: "#f7b047", // Custom border color
              },
              "&:hover fieldset": {
                borderColor: "#ffa726", // Border on hover
              },
              "&.Mui-focused fieldset": {
                borderColor: "#f7b047", // Border when focused
              },
            },
            // backgroundColor: '#fff', // Optional background color
          }}
        />
        <Button
          variant="contained"
          sx={{
            marginRight: "10px",
            marginTop: "6px",
            height: "40px", // Match the TextField height
            backgroundColor: "#f7b047",
            color: "#171d25",
            "&:hover": {
              backgroundColor: "#ffa726",
            },
            textTransform: "none",
            fontWeight: "bold",
          }}
          onClick={() => setOpen(true)}
        >
          Add new teammate
        </Button>
      </div>
      <div className="teammates-main__table-container">
        {filteredTeamData.length != 0 ? (
          <div className="table-scroll">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>First Name</TableCell>
                  <TableCell>Last Name</TableCell>
                  <TableCell>Company</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>Mobile</TableCell>
                  <TableCell>Role</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Allowed States</TableCell> {/* New column */}
                  <TableCell>ReInvite</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredTeamData.map((member: any, index: any) => (
                  <TableRow key={member.id}>
                    <TableCell>{member.firstname}</TableCell>
                    <TableCell>{member.lastname}</TableCell>
                    <TableCell>{member.company || "-"}</TableCell>
                    <TableCell>{member.email}</TableCell>
                    <TableCell>{member.contact || "-"}</TableCell>
                    <TableCell>{member.role}</TableCell>
                    <TableCell>{member.status}</TableCell>
                    <TableCell
                      onMouseEnter={(e) => (e.currentTarget.style.border = "1px solid white")}
                      onMouseLeave={(e) => (e.currentTarget.style.border = "none")}
                     sx={{
                      cursor:"pointer",
                      "&:hover": {
                        border: "1px solid white",
                        cursor: "pointer", // Optional for a better user experience
                      },
                    }} 
                      onClick={()=>handleStatePopover(member.allowed_states,member.email)}>
                      {/* New logic for allowed states */}
                      {member.allowed_states?.length === US_STATES.length 
                        ? "All"
                        : member.allowed_states
                            ?.map(
                              (state: string) =>
                                stateAbbreviations[state] || state
                            )
                            .join(", ") || "All"}
                    </TableCell>
                    <TableCell>
                      {member.status === "pending" ||
                      member.status === "locked" ? (
                        <span onClick={() => handleReInvite(member)}>
                          <LocalPostOfficeIcon style={{ cursor: "pointer" }} />
                        </span>
                      ) : (
                        "-"
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        ) : (
          <div className="homesales-main__chartContainer__noData">
            No Data Available
          </div>
        )}
      </div>
      <BootstrapDialog
        onClose={handleCloseDialog}
        aria-labelledby="customized-dialog-title"
        open={isOpen}
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleCloseDialog}
        >
          <div style={{ textAlign: "center" }}>
            <img
              id="Header-Logo"
              alt="header-logo"
              src={Logo}
              className="header-logo"
              height="80px"
              width="70px"
              onClick={() => {}}
            />
            <p style={{ padding: 0, margin: 0, marginTop: "-8px" }}>
              {" "}
              Add Account
            </p>
          </div>
        </BootstrapDialogTitle>
        <DialogContent dividers>{getForms()}</DialogContent>
      </BootstrapDialog>
      <BootstrapDialog
        onClose={handleCloseStateDialog}
        aria-labelledby="customized-dialog-title"
        open={isStateOpen}
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleCloseStateDialog}
        >
          <div style={{ textAlign: "center" }}>
           
            <p style={{ padding: 0, margin: 0, marginTop: "-8px" }}>
              {" "}
              Update State
            </p>
          </div>
        </BootstrapDialogTitle>
        <DialogContent dividers>{getStatesDropDown()}</DialogContent>
      </BootstrapDialog>
      <ToastContainer />

      {/* Search bar */}

      {/* Table */}
    </div>
  );
};

export default Teammates;
